//Generated File 
export const DOCX = `DOCX`;
export const HTML = `HTML`;
export const JasperPrint = `JasperPrint`;
export const ODS = `ODS`;
export const ODT = `ODT`;
export const PDF = `PDF`;
export const PPTX = `PPTX`;
export const RTF = `RTF`;
export const TXT = `TXT`;
export const XLS = `XLS`;
export const XLSX = `XLSX`;
